import React from "react";
import { Check } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const STEP_KEYS = [
  "stepInquiry",
  "stepStarted",
  "stepSubmitted",
  "stepReview",
  "stepAccepted",
  "stepEnrolled",
  "stepActive",
];

const STATUS_TO_INDEX = {
  inquiry: 0,
  started: 1,
  submitted: 2,
  under_review: 3,
  evaluation_sent: 3,
  evaluation_received: 3,
  accepted: 4,
  enrolled: 5,
  scheduled: 5,
  active: 6,
};

export function JourneyTimeline({ status }) {
  const { t } = useLang();
  const currentIdx = STATUS_TO_INDEX[status] ?? 0;

  return (
    <div data-testid="journey-timeline" className="w-full overflow-x-auto pb-2">
      <ol className="flex items-start gap-2 min-w-[640px]">
        {STEP_KEYS.map((key, i) => {
          const state = i < currentIdx ? "done" : i === currentIdx ? "active" : "todo";
          return (
            <li key={key} className={`timeline-step flex-1 relative ${state}`}>
              <div className="flex items-center">
                <div className={`step-dot w-3 h-3 rounded-full transition-all ${state === "todo" ? "bg-border" : ""}`} />
                {i < STEP_KEYS.length - 1 && (
                  <div className={`flex-1 h-px ${i < currentIdx ? "bg-primary" : "bg-border"}`} />
                )}
              </div>
              <div className="mt-3 pr-2">
                <div className={`text-xs font-medium ${state === "active" ? "text-accent" : state === "done" ? "text-foreground" : "text-muted-foreground"}`}>
                  {state === "done" && <Check className="inline w-3 h-3 mr-1" />}
                  {t(`parent.${key}`)}
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
